import { CastHelper } from './cast.helper';
import { BaseFiltersDto } from './base.dto';
import { Transform } from 'class-transformer';
import {
  IsArray,
  IsDate,
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';
import { TagType } from '@coworkrz/cards/types';
import { ProductUnit } from '@coworkrz/products/types';

export class PricesFiltersDto extends BaseFiltersDto {
  @IsOptional()
  @Transform(({ value }) => CastHelper.toBoolean(value))
  active?: boolean;

  @IsOptional()
  @IsUUID()
  productId?: string;

  @Transform(({ value }) => CastHelper.trim(value))
  @IsOptional()
  @IsEnum(TagType)
  tag?: TagType;

  @IsOptional()
  @IsArray()
  units?: ProductUnit[];
}

export class PriceDto {
  @IsNotEmpty()
  @Transform(({ value }) => Number(value), { toClassOnly: true })
  amount: number;

  @IsNotEmpty()
  @IsDate()
  @Transform(({ value }) => new Date(value), { toClassOnly: true })
  startDate: Date;

  @IsOptional()
  endDate?: Date;

  @IsOptional()
  isActive?: boolean;

  @IsNotEmpty()
  @IsString()
  unit: ProductUnit;

  @IsOptional()
  @IsString()
  idProduct?: string;
}
